var $459c636d0d282e8f$exports = {};
$459c636d0d282e8f$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Data selectat\u{103} nu este disponibil\u{103}`,
            other: `Datele selectate nu sunt disponibile`
        })}.`
};


export {$459c636d0d282e8f$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
